"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var Types = _interopRequireWildcard(require("../types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var FormContext = /*#__PURE__*/_react.default.createContext({
  addAdditionalInputProp: function addAdditionalInputProp() {},
  addFieldValidation: function addFieldValidation() {},
  addFormValidation: function addFormValidation() {},
  addValidationMessages: function addValidationMessages() {},
  clearAllValidationMessages: function clearAllValidationMessages() {},
  clearValidationMessages: function clearValidationMessages() {},
  disabled: false,
  formData: {},
  i18n: {},
  initializeField: function initializeField() {},
  getButtonLabel: function getButtonLabel() {
    return "";
  },
  getFieldLabel: function getFieldLabel() {
    return "";
  },
  getFieldValidationMessages: function getFieldValidationMessages() {
    return [];
  },
  getHighestValidationMessageType: function getHighestValidationMessageType() {
    return undefined;
  },
  getFieldValue: function getFieldValue() {
    return "";
  },
  getFormData: function getFormData() {
    return {};
  },
  isActing: false,
  isCanceling: false,
  isDeleting: false,
  isSubmitting: false,
  removeFieldValidation: function removeFieldValidation() {},
  removeFormValidation: function removeFormValidation() {},
  setFieldValue: function setFieldValue() {},
  setIsCanceling: function setIsCanceling() {},
  setIsDeleting: function setIsDeleting() {},
  setIsSubmitting: function setIsSubmitting() {},
  terminateField: function terminateField() {},
  type: Types.FormContext.Types.Create,
  validateField: function validateField() {
    return [];
  },
  validateForm: function validateForm() {
    return [];
  },
  validations: {
    field: [],
    form: []
  }
});
var _default = FormContext;
exports.default = _default;